/* Collection Family Descriptions — Read more/less for the 2-line clamped
 * family description under each section title (.cfs-desc, server-rendered in
 * blocks/collection-product-grid.liquid).
 *
 * The toggle button ships hidden; it is revealed ONLY when the clamped text
 * actually overflows (scrollHeight vs clientHeight), so short descriptions
 * never show a dead control. Overflow is re-checked on resize and when the
 * section's layout mode changes (solo <-> row can change available width).
 */
(function () {
  'use strict';

  function initDesc(desc) {
    var text = desc.querySelector('[data-family-desc-text]');
    var toggle = desc.querySelector('[data-family-desc-toggle]');
    if (!text || !toggle) return;

    function expanded() {
      return desc.classList.contains('is-expanded');
    }

    function syncToggle() {
      if (expanded()) return; // keep "Read less" visible while open
      // +1 tolerance for subpixel rounding
      toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
    }

    var label = toggle.querySelector('[data-desc-toggle-label]');
    var icon = toggle.querySelector('[data-desc-toggle-icon]');

    toggle.addEventListener('click', function () {
      var open = !expanded();
      desc.classList.toggle('is-expanded', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'Read less' : 'Read more';
      else toggle.textContent = open ? 'Read less' : 'Read more';
      if (icon) {
        // Phosphor webfont glyphs (theme-wide icon set): caret-down/caret-up.
        icon.classList.toggle('ph-caret-down', !open);
        icon.classList.toggle('ph-caret-up', open);
      }
      if (!open) syncToggle();
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(syncToggle).observe(text);
    } else {
      window.addEventListener('resize', syncToggle);
    }
    syncToggle();
  }

  function init() {
    document.querySelectorAll('[data-family-desc]').forEach(initDesc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
